import { Banner, Heading } from '@boltenergy-be/design-system'
import ItsmeButton from 'components/itsme-button/ItsmeButton'
import { ItsmeButtonProps } from 'components/itsme-button/types'
import { Trans, useTranslation } from 'next-i18next/pages'
import Link from 'components/link/Link'
import { routes } from 'utils/routes'
import { useRouter } from 'next/router'

const ItsmeView = ({ isConfirmation }: Pick<ItsmeButtonProps, 'isConfirmation'>) => {
  // i18n
  const { t } = useTranslation('registration')

  // Router
  const { locale } = useRouter()

  return (
    <>
      <header className="flex-col gap-400">
        <Heading as="h1" variant="h4" serif>
          {t('itsme.title')}
        </Heading>
        <p>{t('itsme.paragraph1')}</p>
        <p>{t('itsme.paragraph2')}</p>
      </header>

      <ItsmeButton className="my-500" {...{ isConfirmation }} />

      <small className="text-subdued text-sm">{t('itsme.dataFetched')}</small>

      <Banner className="mt-600" as="section" type="neutral" icon="exclamation" title={t('itsme.warning.title')}>
        {t('itsme.warning.description')}
      </Banner>

      <section className="mt-800">
        <Heading as="h2" variant="h5" serif className="mb-400">
          {t('itsme.troubles.title')}
        </Heading>
        <p>
          <Trans
            {...{ t }}
            i18nKey="itsme.troubles.description"
            components={[<Link variant="inline" href={`${routes(locale).faq}#itsme`} />]}
          />
        </p>
      </section>
    </>
  )
}

export default ItsmeView
